module.exports = __FOREMAN_VENDOR__REACT_REDUX__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_REDUX__"
// module id = react-redux
// module chunks = 0 1 2